import {
	afterNextRender,
	Component,
	computed,
	ElementRef,
	input,
	model,
	output,
	signal,
	viewChild,
} from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';
import { IconModule } from '../icon/icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@Component({
	selector: 'ui-textarea',
	imports: [IconModule, TooltipModule],
	templateUrl: './textarea.component.html',
})
export class TextareaComponent implements FormValueControl<string> {
	autofocus = input<boolean>(false);
	disabled = input<boolean>(false);
	errorText = input<string>('');
	inputId = input<string>('');
	invalid = input<boolean>(false);
	placeholder = input<string>('');
	showWhenValid = input<boolean>(false);
	resizeDisabled = input<boolean>(false);
	singleLine = input<boolean>(false);

	value = model<string>('');

	touch = output<void>();
	valueChanged = output<string>();

	textarea = viewChild<ElementRef<HTMLTextAreaElement>>('textarea');

	showError = computed(() => this.blurred() && this.invalid() && !!this.value());

	showSuccess = computed(
		() => !this.focused() && !this.invalid() && this.showWhenValid() && !!this.value()
	);

	blurred = signal(false);
	focused = signal(false);

	constructor() {
		afterNextRender(() => {
			if (this.autofocus()) {
				this.focus();
			}
		});
	}

	focus(): void {
		this.textarea()?.nativeElement.focus();
	}

	onInput(event: Event): void {
		const value = (event.target as HTMLTextAreaElement).value;
		this.value.set(value);
		this.valueChanged.emit(value);
	}

	onFocusOut() {
		this.focused.set(false);
		this.blurred.set(true);
		this.touch.emit();
	}

	onFocusIn() {
		this.focused.set(true);
		this.blurred.set(false);
	}
}
